import React from 'react';

const PrevArrow = (props: any) => {
  const { className, onClick } = props;
  const disabledClass = className.indexOf("slick-disabled") > -1 ? " hide-smooth" : "";
  return (
    <button onClick={onClick} className={`slide-button slide-button_prev${disabledClass}`}>
      <svg version="1.1" x="0px" y="0px" viewBox="0 0 15 26">
        <polygon className="st0" points="13.4,26 15,23.9 3.8,13.1 15,2.1 13.4,0 0,13.1 " fill="#ffffff" />
      </svg>
    </button>
  );
};

export default PrevArrow;
